import types from '../types';

const tradeVolumeSettings = (
  state = { loading: true, data: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_TRADE_VOLUME_SETTINGS_START:
      return { ...state, loading: true };

    case types.GET_TRADE_VOLUME_SETTINGS_FAILURE:
      return { ...state, loading: false };

    case types.GET_TRADE_VOLUME_SETTINGS_SUCCESS:
      return { ...state, data: payload, loading: false };

    default:
      return state;
  }
};

export default tradeVolumeSettings;
